export default {"src":"/_next/static/media/Wim-Van-Cappellen1.caab7948.JPG","height":1040,"width":1560};